import { render, staticRenderFns } from "./VehicleCalculation.vue?vue&type=template&id=c4906b8a&scoped=true&"
import script from "./VehicleCalculation.vue?vue&type=script&lang=js&"
export * from "./VehicleCalculation.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCalculation.vue?vue&type=style&index=0&id=c4906b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4906b8a",
  null
  
)

export default component.exports